//@ts-nocheck

import React from 'react'
import AssetCardVertical from '../../../../../AssetCardVertical/AssetCardVertical'
import { getAssetType } from '../../../../commons/util'
import Tooltip from '../../../../../Tooltip/Tooltip'
import BranchDisplay from '../../../../../BranchDisplay/BranchDisplay'

const assetType = {
  "null": 'image',
  "Document": "document",
  'Group': "folder",
  'Pdf': 'pdf',
  'Archive': 'zip',
  'Video': 'video',
  'Audio': 'audio'
}

export default React.memo(
  (props) => {
    const { asset, checked, updateSelection, isMultiple, readOnly, vendor, hasBranchFeature, isFolderSelection, viewOnly } = props
    const { url, title, file_size, uid, content_type, name, file_name, filename, filesize, isLottie } = asset
    const assetTitle = Array.isArray(title) ? title[0] : title;
    const assetName = Array.isArray(name) ? name[0] : name;
    const assetFileName = Array.isArray(file_name) ? file_name[0] : Array.isArray(filename) ? filename[0] : file_name;
    const assetContentType = Array.isArray(content_type) ? content_type[0] : content_type;
    const assetUrl = Array.isArray(url) ? url[0] : url;
    const assetFileSize = Array.isArray(file_size) ? file_size[0] : Array.isArray(filesize) ? filesize[0] : file_size;

    // 'branch-display-dom' is UI-React dom element
    let appendToId = 'branch-display-dom'
    let branchDisplayDOM = document.getElementById('branch-display-dom')
    // Temporary element for the venus to render in Storybook
    // 'venus-branch-display-dom' is Storybook dom element
    if (!branchDisplayDOM) {
      appendToId = 'venus-branch-display-dom'
      branchDisplayDOM = document.createElement('div')
      branchDisplayDOM.id = appendToId
      document.body.appendChild(branchDisplayDOM)
      branchDisplayDOM = document.getElementById(appendToId)
    }

    return (<>
      {hasBranchFeature ? <Tooltip
        content={
          <BranchDisplay
            moduleType={asset.is_dir ? 'folder' : 'asset'}
            moduleVal={asset}
            titleKey={asset.is_dir ? 'name' : 'filename'}
            vendor={vendor || ''}
          />
        }
        appendTo={branchDisplayDOM}
        position="right"
        showArrow={false}
        variantType="light"
      >
        <AssetCardVertical
          {...((!viewOnly || asset.is_dir) && { onCardClick:() => (!viewOnly || asset.is_dir) && updateSelection(checked, asset, true)} )} // boolean is to represent folder navigation, if it is folder picker modal
          assetUrl={assetUrl}
          isLottie={isLottie}
          title={assetTitle ?? assetName ?? assetFileName}
          size={assetFileSize}
          assetType={assetType[getAssetType(assetContentType)]}
          imageWidth={'100%'}
          {...(!viewOnly && { checked: checked })}
          isCardDisabled={asset?.invalid_asset}
          {...(!viewOnly && { isRadio: !isMultiple })}
          {...((!viewOnly || asset.is_dir) && (isFolderSelection || !asset.is_dir) && !readOnly && { onChecked: () => updateSelection(checked, asset, false) })}
        />
      </Tooltip> :
        <AssetCardVertical
          {...((!viewOnly || asset.is_dir) && { onCardClick:() => (!viewOnly || asset.is_dir) && updateSelection(checked, asset, true)} )}
          assetUrl={assetUrl}
          isLottie={isLottie}
          title={assetTitle ?? assetName ?? assetFileName}
          size={assetFileSize}
          assetType={assetType[getAssetType(assetContentType)]}
          imageWidth={'100%'}
          {...(!viewOnly && { checked: checked })}
          isCardDisabled={asset?.invalid_asset}
          {...(!viewOnly && { isRadio: !isMultiple })}
          {...((!viewOnly || asset.is_dir) && (isFolderSelection || !asset.is_dir) && !readOnly && { onChecked: () => updateSelection(checked, asset, false) })}
        />
      }</>
    )
  },
  (prev, curr) => {
    return prev.checked === curr.checked
  }
)
